/* global axios */

const buildUrl = (accountId, scope) => {
  const base = `/api/v1/accounts/${accountId}/nexceo`;
  if (scope?.leadId) return `${base}/leads/${scope.leadId}/ai_logs`;
  if (scope?.projectId) return `${base}/projects/${scope.projectId}/ai_logs`;
  return `${base}/ai_logs`;
};

export default {
  list(accountId, scope = {}, filters = {}) {
    return axios.get(buildUrl(accountId, scope), { params: filters });
  },

  show(accountId, logId, scope = {}) {
    return axios.get(`${buildUrl(accountId, scope)}/${logId}`);
  },

  getLeadLogs(accountId, leadId, filters = {}) {
    return axios.get(
      `/api/v1/accounts/${accountId}/nexceo/leads/${leadId}/ai_logs`,
      { params: filters }
    );
  },

  getAnalytics(accountId, filters = {}) {
    return axios.get(`/api/v1/accounts/${accountId}/nexceo/ai_logs`, {
      params: { ...filters, limit: 0 },
    });
  },
};
